import { useEffect, useRef } from "react";
import { useAuthStore } from "../stores/auth";
import { refreshToken } from "../services/auth/refresh";
import { axios } from "../libs/axios";

type Props = {
  children: React.ReactNode;
};

export const AuthProvider = ({ children }: Props) => {
  const user = useAuthStore((state) => state.user);
  const setUser = useAuthStore((state) => state.setUser);
  const hasAttemptedRecovery = useRef(false);

  useEffect(() => {
    const attemptTokenRecovery = async () => {
      // Only attempt recovery if:
      // 1. We have a persisted user (indicating they were logged in)
      // 2. We haven't already attempted recovery
      // 3. User is not anonymous (anonymous users don't need token recovery)
      if (!user || hasAttemptedRecovery.current || user.isAnonymous) {
        return;
      }

      hasAttemptedRecovery.current = true;

      try {
        // Attempt to refresh the token
        await refreshToken(axios);
        console.log("Token recovery successful");
      } catch (error) {
        console.log("Token recovery failed, clearing user state:", error);
        // If refresh fails, clear the persisted user state
        // This will force the user to log in again
        setUser(null);
      }
    };

    attemptTokenRecovery();
  }, [user, setUser]);

  return <>{children}</>;
}; 